<template>
  <div>
    <Spin fix v-show="isSpinShow">
      <Icon type="ios-loading" size="18" class="spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <Table ref="selection" :data="data" :columns="columns"></Table>
    <Page
      :current="currentPage"
      :total="dataCount"
      :page-size="pageSize"
      show-sizer
      show-total
      @on-change="changePage"
      @on-page-size-change="changePageSize"
    ></Page>
  </div>
</template>
<script>
export default {
  props: {
    condition: {},
    callback: {
      type: Function,
    },
  },
  mounted() {
    this.columns = [
      {
        title: " ",
        width: 60,
        key: "checkBox",
        render: (h, params) => {
          return h("Checkbox", {
            props: {
              value: params.row.checkBox,
            },
            on: {
              "on-change": (val) => {
                this.data.forEach((items) => {
                  //先取消所有对象的勾选，checkBox设置为false
                  this.$set(items, "checkBox", false);
                });
                this.data[params.index].checkBox = val;
                if (val) {
                  this.selectIndex = params.index;
                } else {
                  this.selectIndex = -1;
                }
                this.callback(this.data[this.selectIndex]);
              },
            },
          });
        },
      },
      {
        title: "设备编号",
        key: "meterId",
      },
      {
        width: 400,
        title: "设备地址",
        key: "addressLowestLevelAddressIds",
      },
      {
        title: "用户姓名",
        key: "customerName",
      },
      {
        title: "设备类型",
        key: "meterTypeName",
      },
    ];
    this.viewMeterDetailed = this.condition;
    this.getMeterList();
  },
  data() {
    return {
      dataCount: 0,
      pageSize: 10,
      currentPage: 1,
      selectIndex: -1,
      isSpinShow: false,
      data: [],
      columns: [],
      viewMeterDetailed: {},
    };
  },
  methods: {
    changePage(index) {
      this.currentPage = index;
      this.selectIndex = -1;
      this.callback(null);
      this.getMeterList();
    },
    changePageSize(size) {
      this.pageSize = size;
      this.selectIndex = -1;
      this.callback(null);
      this.getMeterList();
    },
    getMeterList() {
      //查询表具信息
      if (this.isSpinShow == false) {
        this.isSpinShow = true;
      }
      this.selectIndex = -1;
      this.viewMeterDetailed["page"] = this.currentPage;
      this.viewMeterDetailed["pageAmount"] = this.pageSize;
      var that = this;
      $.ajax({
        url:
          "/api/getMeterInfoForSearch?page=" +
          this.currentPage +
          "&pageAmount=" +
          this.pageSize,
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({ meterType: 8, ...that.viewMeterDetailed }),
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.errorCode == 0) {
            that.data = receiveData.body.resultList;
            that.dataCount = receiveData.body.amount;
            that.pageSize = receiveData.body.pageAmount;
            that.currentPage = receiveData.body.page;
          } else {
            that.$Notice.error({
              title: "异常",
              desc: receiveData.errorInfo,
            });
          }
          that.isSpinShow = false;
        },
        error: function(textStatus) {
          that.isSpinShow = false;
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常",
          });
        },
      });
    },
  },
};
</script>
<style>
.spin-icon-load {
  animation: ani-spin 1s linear infinite;
}

@keyframes ani-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
